import { CustomerSettings } from '../../shared/models/customer-settings.model';
import * as CustomerSettingsActions from '../actions/customer-settings';

export type State = CustomerSettings;

export const InitialState: State = {
	id: 0,
	type: '',
	createdBy: '',
	agencyId: '',
	watchedIntroJs: false,
};

export function reducer(state: State = InitialState, action: CustomerSettingsActions.All): State {
	switch (action.type) {
		case CustomerSettingsActions.SAVE_CUSTOMER_SETTINGS_SUCCESS:
			return action.payload;

		default:
			return state;
	}
}

export const customerSettings = (s: State): CustomerSettings => s;



// WEBPACK FOOTER //
// ./src/app/xena/core/state-management/reducers/customer-settings.ts